import { useState } from 'react';
import { authAPI } from '../services/api/authAPI';

export const usePasswordReset = () => {
  const [isResetting, setIsResetting] = useState(false);

  const requestPasswordReset = async (email) => {
    if (!email || !email.includes('@')) {
      alert('Introduceți un email valid pentru resetarea parolei');
      return { success: false };
    }

    setIsResetting(true);
    
    try {
      await authAPI.requestPasswordReset(email.trim());
      alert('Dacă există un cont cu acest email, instrucțiunile au fost trimise.');
      return { success: true };
    } catch (error) {
      alert('Eroare la resetarea parolei. Încercați din nou.');
      return { success: false, error: error.message };
    } finally {
      setIsResetting(false);
    }
  };

  return {
    isResetting,
    requestPasswordReset
  };
};
